package oldcomponents.page

import bootstrap.LinkContainer
import react.*
import react.dom.*

data class Breadcrumb(
    val url: String,
    val name: String,
    val icon: String
)

external interface PageHeaderProps : Props {
    var header: String
    var helpLink: String
    var breadcrumbs: List<Breadcrumb>
}

val pageHeader = fc<PageHeaderProps> { props ->
    div("row") {
        div("page-header") {
            div("d-flex align-items-center") {
                h2("page-header-title") {
                    if (undefined != props.helpLink) {
                        +"${props.header} ("
                        a(href = props.helpLink, target = "_blank") {
                            attrs.jsStyle { display = "inline-block" }
                            +"?"
                        }
                        +")"
                    } else {
                        +props.header
                    }
                }
                if (props.breadcrumbs != undefined && props.breadcrumbs.isNotEmpty()) {
                    div {
                        ul("breadcrumb") {
                            props.breadcrumbs.forEachIndexed { index, breadcrumb ->
                                if (index < props.breadcrumbs.size - 1) {
                                    LinkContainer {
                                        attrs.to = breadcrumb.url
                                        li("breadcrumb-item") {
                                            a(breadcrumb.url) {
                                                if (breadcrumb.icon.isNotBlank()) {
                                                    i(breadcrumb.icon) {}
                                                }
                                                +breadcrumb.name
                                            }
                                        }
                                    }
                                } else {
                                    li("breadcrumb-item active") {
                                        if (breadcrumb.icon.isNotBlank()) {
                                            i(breadcrumb.icon) {}
                                        }
                                        +breadcrumb.name
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

fun RBuilder.pageHeader(props: PageHeaderProps) {
    child(pageHeader, props)
}